export default __webpack_public_path__ + "static/media/subscribeSuccess.edfc7b5f.svg";